module.exports = __webpack_public_path__ + "static/media/leaf0001.dbd2bdcc.gif";